import React, {
  useState,
  useRef
} from 'react';
import { capitalCase } from 'change-case';
import PropTypes from 'prop-types';
import { Link as RouterLink} from 'react-router-dom';
import {
  Select,
  MenuItem,
  makeStyles
} from '@material-ui/core';
import { Settings as SettingsIcon } from 'react-feather';
import Flag from 'src/components/Flag';
import useSettings from 'src/hooks/useSettings';
import { THEMES } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  badge: {
    height: 10,
    width: 10,
    borderRadius: 5,
    marginTop: 10,
    marginRight: 5
  },
  popover: {
    width: 320,
    padding: theme.spacing(2)
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
}));

// const Settings = () => {
//   const classes = useStyles();
//   const ref = useRef(null);
//   const { settings, saveSettings } = useSettings();
//   const [isOpen, setOpen] = useState(false);
//   const [values, setValues] = useState({
//     direction: settings.direction,
//     responsiveFontSizes: settings.responsiveFontSizes,
//     theme: settings.theme
//   });

  
  
  const Nations = ({
    className,
    ...rest
  }) => {const classes = useStyles();

  return (
    <>
      <Select
          variant="standard"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          disableUnderline
          defaultValue="ENG"
        >
          <MenuItem value='ENG'>
              <RouterLink to="/eng" >
                <Flag className={classes.logo} lang="eng" />
              </RouterLink>
              {/* <InputLabel>ENG</InputLabel> */}
          </MenuItem>
          <MenuItem value='KOR'>
              <RouterLink to="/kor" >
                <Flag className={classes.logo} lang="kor" />
              </RouterLink>
              {/* <InputLabel>KOR</InputLabel> */}
          </MenuItem>
        </Select>
    </>
  );
};

Nations.propTypes = {
  className: PropTypes.string
};

export default Nations;
